import ReactController from '~/controllers/react_controller'
import AWSRDSClusterMetricsCharts from '~/dashboard/aws_rds_cluster_metrics_charts'

export default class AWSRDSClusterMetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
  }

  createComponent() {
    return <AWSRDSClusterMetricsCharts organizationId={this.organizationIdValue} resourceId={this.resourceIdValue} />
  }
}
